import { GlobalDataContext } from "contexts/GlobalData";
import React, { FC, useContext, useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";


const MePersonalInfo = ({ 
	userData,
	className = "" 
}: any) => {
		
	const { 
		initData,
	} = useContext (GlobalDataContext);

	//{info.residence.main} {info.residence.detail}
	const textUpdateRequired = "업데이트 필요";
	const textSetting = "설정됨";
	const getDrivingExperience = (value: string) => {
		if (value===undefined || value==="" || value===null) {
			return "설정 없음"
		}
		switch (value) {
			case "0":
				return "설정 없음";
			case "1":
				return "경력 없음";
			case "2":
				return "1년 미만";
			case "3":
				return "1년 이상 3년 미만";
			case "4":
				return "3년 이상 5년 미만";
			case "5":
				return "5년 이상 10년 미만";
			case "6":
				return "10년 이상";
		}
	}

	const [info, setInfo] = useState({
		user_id: userData._id,
		displayName: userData.displayName,
		name: `${(userData.familyName === null)? "" : userData.familyName}` + `${(userData.givenName === null)? textUpdateRequired : userData.givenName}`, 
		residence: (userData.residence === null)
			? textUpdateRequired
			: `${userData.residence.main} ${userData.residence.detail}`,
		phoneNumberlast4: userData.phoneNumberlast4,
		birthdate: formatKoreanDate(userData.birthdate).date,
		profileUrl: (userData.profileUrl===undefined || userData.profileUrl==="" || userData.profileUrl===null)
			? textUpdateRequired
			: textSetting,
		license: (userData.licenseUrl===undefined || userData.licenseUrl==="" || userData.licenseUrl===null)
			? textUpdateRequired
			: textSetting,
		passport: (userData.passportUrl===undefined || userData.passportUrl==="" || userData.passportUrl===null)
			? textUpdateRequired
			: textSetting,
		motorcycles: (userData.motorcycles===undefined || userData.motorcycles==="" || userData.motorcycles===null)
			? textUpdateRequired
			: userData.motorcycles,
		drivingExperience: getDrivingExperience(userData.drivingExperience)
	});



	useEffect(()=>{
		if (initData.token_info.permission_group === "guest") {
			//user_displayName
			
		}
		
		// console.log("initData");
		// console.log(initData);
		// const _formatKoreanDate = ;
		// console.log(_formatKoreanDate);
	}, []);

	function formatKoreanDate(dateString: string) {
		const date = new Date(dateString);
		
		const year = date.getFullYear();
		const month = ('0' + (date.getMonth() + 1)).slice(-2);
		const day = ('0' + date.getDate()).slice(-2);
		
		let hours = date.getHours();
		const minutes = ('0' + date.getMinutes()).slice(-2);
		const seconds = ('0' + date.getSeconds()).slice(-2);
	
		const period = hours >= 12 ? '오후' : '오전';
		hours = hours % 12 || 12; // 0 => 12
	
		const formattedDate = `${year}-${month}-${day}`;
		const formattedTime = `${period} ${hours}:${minutes}:${seconds}`;
	
		return {
			date: formattedDate,
			time: formattedTime
		};
	}
	


	return (
		<>
			<h2 className="text-[0.95rem] font-semibold flex-grow mt-10" style={{fontWeight: "600", color:"#282f33"}}>
				개인정보
			</h2>	
			<div
				className={`nc-WidgetCategories rounded-xl  overflow-hidden bg-neutral-100 dark:bg-neutral-800 mt-2`}
				data-nc-id="WidgetCategories"
			>
				<div className="flow-root">
					<div className="flex flex-col divide-y divide-neutral-200 dark:divide-neutral-700">
						
						<div
							className={`nc-CardCategory1 flex items-center bg-neutral-100 dark:bg-neutral-800 pt-3 pb-3`}
						>	
							<div className="w-full flex justify-between ml-10">
								<div>
									<h2
										className={`nc-card-title text-[0.95rem]`}
										style={{fontWeight: "600", color:"#282f33"}}
									>
										프로필 이미지
									</h2>
									<span
										className={`block mt-[2px] text-[0.9rem]`}
										style={{fontWeight: "500", color:"#586066"}}
									>
										{info.profileUrl}
									</span>
								</div>
								<Link
									to={'/me/modify-avatarimg'}
									className={`flex items-center mr-10 text-[0.9rem]`}
									style={{fontWeight: "500", color:"#282f33"}}
								>
									수정
								</Link>
							</div>
						</div>

						<div
							className={`nc-CardCategory1 flex items-center bg-neutral-100 dark:bg-neutral-800 pt-3 pb-3`}
						>	
							<div className="w-full flex justify-between ml-10">
								<div>
									<h2
										className={`nc-card-title text-[0.95rem]`}
										style={{fontWeight: "600", color:"#282f33"}}
									>
										닉네임
									</h2>
									<span
										className={`block mt-[2px] text-[0.9rem]`}
										style={{fontWeight: "500", color:"#586066"}}
									>
										{info.displayName}
									</span>
								</div>
								<Link
									to={'/me/modify-displayname'}
									className={`flex items-center mr-10 text-[0.9rem]`}
									style={{fontWeight: "500", color:"#282f33"}}
								>
									수정
								</Link>
							</div>
						</div>

						<div
							className={`nc-CardCategory1 flex items-center bg-neutral-100 dark:bg-neutral-800 pt-3 pb-3`}
						>	
							<div className="w-full flex justify-between ml-10">
								<div>
									<h2
										className={`nc-card-title text-[0.95rem]`}
										style={{fontWeight: "600", color:"#282f33"}}
									>
										이름
									</h2>
									<span
										className={`block mt-[2px] text-[0.9rem]`}
										style={{fontWeight: "500", color:"#586066"}}
									>
										{info.name}
									</span>
								</div>
								<Link 
									to={'/me/modify-name'}
									className={`flex items-center mr-10 text-[0.9rem]`}
									style={{fontWeight: "500", color:"#282f33"}}
								>
									수정
								</Link>
							</div>
						</div>

						<div
							className={`nc-CardCategory1 flex items-center bg-neutral-100 dark:bg-neutral-800 pt-3 pb-3`}
						>
							<div className="w-full flex justify-between ml-10">
								<div>
									<h2
										className={`nc-card-title text-[0.95rem]`}
										style={{fontWeight: "600", color:"#282f33"}}
									>
										연락처
									</h2>
									<span
										className={`block mt-[2px] text-[0.9rem]`}
										style={{fontWeight: "500", color:"#586066"}}
									>
										{info.phoneNumberlast4}
									</span>
								</div>
								<Link 
									to={'/me/modify-phonenumber'}
									className={`flex items-center mr-10 text-[0.9rem]`}
									style={{fontWeight: "500", color:"#282f33"}}
								>
									수정
								</Link>
							</div>
						</div>

						<div
							className={`nc-CardCategory1 flex items-center bg-neutral-100 dark:bg-neutral-800 pt-3 pb-3`}
						>
							<div className="w-full flex justify-between ml-10">
								<div>
									<h2
										className={`nc-card-title text-[0.95rem]`}
										style={{fontWeight: "600", color:"#282f33"}}
									>
										거주지
									</h2>
									<span
										className={`block mt-[2px] text-[0.9rem]`}
										style={{fontWeight: "500", color:"#586066"}}
									>
										{info.residence}
									</span>
								</div>
								<Link 
									to={'/me/modify-residence'}
									className={`flex items-center mr-10 text-[0.9rem]`}
									style={{fontWeight: "500", color:"#282f33"}}
								>
									수정
								</Link>
							</div>
						</div>

						<div
							className={`nc-CardCategory1 flex items-center bg-neutral-100 dark:bg-neutral-800 pt-3 pb-3`}
						>
							<div className="w-full flex justify-between ml-10">
								<div>
									<h2
										className={`nc-card-title text-[0.95rem]`}
										style={{fontWeight: "600", color:"#282f33"}}
									>
										생년월일
									</h2>
									<span
										className={`block mt-[2px] text-[0.9rem]`}
										style={{fontWeight: "500", color:"#586066"}}
									>
										{info.birthdate}
									</span>
								</div>
								<Link 
									to={'/me/modify-birthdate'}
									className={`flex items-center mr-10 text-[0.9rem]`}
									style={{fontWeight: "500", color:"#282f33"}}
								>
									수정
								</Link>
							</div>
						</div>

						<div
							className={`hidden nc-CardCategory1 flex items-center bg-neutral-100 dark:bg-neutral-800 pt-3 pb-3`}
						>
							<div className="w-full flex justify-between ml-10">
								<div>
									<h2
										className={`nc-card-title text-[0.95rem]`}
										style={{fontWeight: "600", color:"#282f33"}}
									>
										면허정보
									</h2>
									<span
										className={`block mt-[2px] text-[0.9rem]`}
										style={{fontWeight: "500", color:"#586066"}}
									>
										{info.license}
									</span>
								</div>
								<Link 
									to={'/me/modify-license'}
									className={`flex items-center mr-10 text-[0.9rem]`}
									style={{fontWeight: "500", color:"#282f33"}}
								>
									수정
								</Link>
							</div>
						</div>

						<div
							className={`hidden nc-CardCategory1 flex items-center bg-neutral-100 dark:bg-neutral-800 pt-3 pb-3`}
						>
							<div className="w-full flex justify-between ml-10">
								<div>
									<h2
										className={`nc-card-title text-[0.95rem]`}
										style={{fontWeight: "600", color:"#282f33"}}
									>
										여권정보
									</h2>
									<span
										className={`block mt-[2px] text-[0.9rem]`}
										style={{fontWeight: "500", color:"#586066"}}
									>
										{info.passport}
									</span>
								</div>
								<Link 
									to={'/me/modify-passport'}
									className={`flex items-center mr-10 text-[0.9rem]`}
									style={{fontWeight: "500", color:"#282f33"}}
								>
									수정
								</Link>
							</div>
						</div>

						<div
							className={`nc-CardCategory1 flex items-center bg-neutral-100 dark:bg-neutral-800 pt-3 pb-3`}
						>	
							<div className="w-full flex justify-between ml-10">
								<div>
									<h2
										className={`nc-card-title text-[0.95rem]`}
										style={{fontWeight: "600", color:"#282f33"}}
									>
										보유 기종
									</h2>
									<span
										className={`block mt-[2px] text-[0.9rem]`}
										style={{fontWeight: "500", color:"#586066"}}
									>
										{info.motorcycles}
									</span>
								</div>
								<Link
									to={'/me/modify-motorcycles'}
									className={`flex items-center mr-10 text-[0.9rem]`}
									style={{fontWeight: "500", color:"#282f33"}}
								>
									수정
								</Link>
							</div>
						</div>

						<div
							className={`nc-CardCategory1 flex items-center bg-neutral-100 dark:bg-neutral-800 pt-3 pb-3`}
						>	
							<div className="w-full flex justify-between ml-10">
								<div>
									<h2
										className={`nc-card-title text-[0.95rem]`}
										style={{fontWeight: "600", color:"#282f33"}}
									>
										경력
									</h2>
									<span
										className={`block mt-[2px] text-[0.9rem]`}
										style={{fontWeight: "500", color:"#586066"}}
									>
										{info.drivingExperience}
									</span>
								</div>
								<Link
									to={'/me/modify-drivingExperience'}
									className={`flex items-center mr-10 text-[0.9rem]`}
									style={{fontWeight: "500", color:"#282f33"}}
								>
									수정
								</Link>
							</div>
						</div>


					</div>
				</div>
			</div>
		</>
  	);
};

export default MePersonalInfo;
